import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import APPTTimeslotHeader from './header';
import APPTTimeslot from './time-slot';

const APPTTimeSlots = ({ timeslots, timeslotLength, arrayStartPosition, selectedIndex, handleSelect, disabled, initial }) => {
	const [morningTimes, setMorningTimes] = useState([]);
	const [afternoonTimes, setAfternoonTimes] = useState([]);
	const [eveningTimes, setEveningTimes] = useState([]);

	useEffect(() => {
		getTimeslotTable(arrayStartPosition, timeslotLength, timeslots);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [JSON.stringify(timeslots), timeslotLength, arrayStartPosition, initial]);

	const getTimeslotTable = (arrayStartPosition, timeslotLength, timeslots) => {
		arrayStartPosition = arrayStartPosition || 0;
		timeslotLength = timeslotLength || 0;
		let morningTimeSlotArray = [];
		let afternoonTimeSlotArray = [];
		let eveningTimeSlotArray = [];
		for (let i = arrayStartPosition; i < arrayStartPosition + timeslotLength; i++) {
			const timeSlotStartHour = timeslots?.[i]?.START_DATE?.split('T')?.[1]?.split(':')?.[0];
			const timeSlotStartMin = timeslots?.[i]?.START_DATE?.split('T')?.[1]?.split(':')?.[1];
			const timeSlot = {};
			timeSlot.arrayPosition = i;
			timeSlot.START_DATE = timeslots[i].START_DATE;
			timeSlot.END_DATE = timeslots[i].END_DATE;
			timeSlot.RESOURCE_ID = timeslots[i].RESOURCE_ID;
			timeSlot.period = 'PM';
			timeSlot.time = `${parseInt(timeSlotStartHour)}:${timeSlotStartMin}`;
			if (parseInt(timeSlotStartHour) < 12) {
				timeSlot.period = 'AM';
				morningTimeSlotArray.push(timeSlot);
			} else {
				if (parseInt(timeSlotStartHour) > 12) {
					timeSlot.time = `${parseInt(timeSlotStartHour) - 12}:${timeSlotStartMin}`;
				}
				if ((parseInt(timeSlotStartHour) >= 12 && parseInt(timeSlotStartHour) < 16) || (parseInt(timeSlotStartHour) === 16 && parseInt(timeSlotStartMin) < 1)) {
					afternoonTimeSlotArray.push(timeSlot);
				} else {
					eveningTimeSlotArray.push(timeSlot);
				}
			}
		}
		setMorningTimes(morningTimeSlotArray);
		setAfternoonTimes(afternoonTimeSlotArray);
		setEveningTimes(eveningTimeSlotArray);
	};

	const selectTimeslot = (index) => {
		handleSelect(timeslots[index], index);
	};

	return (
		<>
			<APPTTimeslotHeader />
			<div className='grid grid-cols-3 gap-x-2'>
				<div className='col-span-1 flex flex-col'>
					{morningTimes.map((timeslot) => (
						<APPTTimeslot
							onClick={selectTimeslot}
							selected={selectedIndex === timeslot.arrayPosition ? true : false}
							key={`t${timeslot.arrayPosition}`}
							timeslot={timeslot}
							disabled={disabled}
						/>
					))}
				</div>
				<div className='col-span-1 col-start-2 flex flex-col'>
					{afternoonTimes.map((timeslot) => (
						<APPTTimeslot
							onClick={selectTimeslot}
							selected={selectedIndex === timeslot.arrayPosition ? true : false}
							key={`t${timeslot.arrayPosition}`}
							timeslot={timeslot}
							disabled={disabled}
						/>
					))}
				</div>
				<div className='col-span-1 col-start-3 flex flex-col'>
					{eveningTimes.map((timeslot) => (
						<APPTTimeslot
							onClick={selectTimeslot}
							selected={selectedIndex === timeslot.arrayPosition ? true : false}
							key={`t${timeslot.arrayPosition}`}
							timeslot={timeslot}
							disabled={disabled}
						/>
					))}
				</div>
			</div>
		</>
	);
};

APPTTimeSlots.propTypes = {
	timeslots: PropTypes.array.isRequired,
	arrayStartPosition: PropTypes.number.isRequired,
	timeslotLength: PropTypes.number.isRequired,
	selectedIndex: PropTypes.number,
	handleSelect: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	initial: PropTypes.bool,
};

export default APPTTimeSlots;
